import React from 'react';

import { Typography } from '@bessemercws/components';

const Quicken = () => {
  return <Typography>Quicken page place holder...</Typography>;
};

export default Quicken;
